import { useMemo, useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "../components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EmailVerificationSent = () => {
  const [params] = useSearchParams();
  const email = useMemo(() => params.get("email") || "", [params]);

  const [loading, setLoading] = useState(false);
  const [cooldownUntil, setCooldownUntil] = useState(null);
  const [cooldown, setCooldown] = useState(0);
  useEffect(() => {
    if (!cooldownUntil) return;

    const interval = setInterval(() => {
      const remaining = Math.max(
        0,
        Math.ceil((cooldownUntil - Date.now()) / 1000)
      );

      setCooldown(remaining);

      if (remaining === 0) {
        clearInterval(interval);
        setCooldownUntil(null);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [cooldownUntil]);

  const reason = useMemo(() => params.get("reason") || "register", [params]);

  const resend = async () => {
    if (!email) {
      toast.error("Falta el email.");
      return;
    }
    if (cooldown > 0) return;

    setLoading(true);
    try {
      await axios.post(`${API}/members/resend-verification`, { email });
      toast.success("Correo reenviado. Revisa tu bandeja de entrada.");
      const seconds = 60;
      const until = Date.now() + seconds * 1000;
      setCooldownUntil(until);
      setCooldown(seconds);
    } catch (e) {
      const status = e?.response?.status;
      if (status === 429) {
        const retryAfter = parseInt(e.response.headers?.["retry-after"] || "60", 10);
        toast.error(`Espera ${retryAfter}s antes de reenviar.`);
        const until = Date.now() + retryAfter * 1000;
        setCooldownUntil(until);
        setCooldown(retryAfter);
        return;
      }
      toast.error(e?.response?.data?.detail || "No se pudo reenviar. Inténtalo de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="section-container py-16">
      <div className="max-w-xl mx-auto bg-white/5 border border-white/10 p-8">
        <h1 className="font-['Playfair_Display'] text-3xl text-white mb-3">
          Confirma tu email
        </h1>
        <p className="text-white/60 mb-6">
          {reason === "login" ? (
            <>Tu cuenta aún no está verificada. Te hemos reenviado el correo{email ? ` a ${email}` : ""}. Haz clic en el enlace para activar tu cuenta.</>
          ) : (
            <>Te hemos enviado un correo de verificación{email ? ` a ${email}` : ""}. Haz clic en el enlace para activar tu cuenta.</>
          )}
        </p>
        <div className="flex flex-col gap-3">
          <Button onClick={resend} disabled={loading || cooldown > 0} className="btn-primary">
            {loading ? "Reenviando..." : cooldown > 0 ? `Reenviar (${cooldown}s)` : "Reenviar correo"}
          </Button>

          <Link to="/login" className="btn-outline text-center">
            Ir a iniciar sesión
          </Link>

          <p className="text-white/40 text-xs mt-3">
            Si no lo ves, revisa Spam/Promociones. El enlace caduca en 24 horas.
          </p>
        </div>
      </div>
    </div>
  );
};
